import Vue from 'vue';
import format from 'date-fns/format';
import { isEqual } from 'lodash/core';
import vueAuth from '@common/lib/auth';
import store from '@common/store';
import { ROOT_UPDATE_USER_DEVICE_INFO } from '@common/store/modules/user/types';

/* eslint-disable */
import { $window } from './globals';

const moment = require('moment');

Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

Array.prototype.insert = function(index) {
  this.splice.apply(
    this,
    [index, 0].concat(Array.prototype.slice.call(arguments, 1)),
  );
  return this;
};

Array.prototype.insertAt = function(index) {
  var arrayToInsert = this.splice.apply(arguments, [2]);
  return this.insertArrayAt(index, arrayToInsert);
};

Array.prototype.insertArrayAt = function(index, arrayToInsert) {
  this.splice.apply(this, [index, 0].concat(arrayToInsert));
  return this;
};

if (typeof Object.assign != 'function') {
  Object.assign = function(target, varArgs) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      // Skip over if undefined or null
      if (nextSource != null) {
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

export function camelCase(name) {
  return name.replace(/([\:\-\_]+(.))/g, function(
    _,
    separator,
    letter,
    offset,
  ) {
    // eslint-disable-line
    return offset ? letter.toUpperCase() : letter;
  });
}

export function isUndefined(value) {
  return typeof value === 'undefined';
}

export function isDefined(value) {
  return typeof value !== 'undefined';
}

export function isObject(value) {
  //return value !== null && typeof value === 'object';
  return (
    value !== null && typeof value === 'object' && value.constructor !== Array
  );
}

export function isString(value) {
  return typeof value === 'string';
}

export function isNumber(value) {
  return typeof value === 'number';
}

export function isFunction(value) {
  return typeof value === 'function';
}

export function objectExtend(a, b) {
  // Don't touch 'null' or 'undefined' objects.
  if (a == null || b == null) {
    return a;
  }

  Object.keys(b).forEach(function(key) {
    if (Object.prototype.toString.call(b[key]) == '[object Object]') {
      if (Object.prototype.toString.call(a[key]) != '[object Object]') {
        a[key] = b[key];
      } else {
        a[key] = objectExtend(a[key], b[key]);
      }
    } else {
      a[key] = b[key];
    }
  });

  return a;
}

/**
 * Assemble url from two segments
 *
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {String} baseUrl Base url
 * @param  {String} url     URI
 * @return {String}
 */
export function joinUrl(baseUrl, url) {
  if (/^(?:[a-z]+:)?\/\//i.test(url)) {
    // eslint-disable-line
    return url;
  }
  let joined = [baseUrl, url].join('/');
  let normalize = function(str) {
    return str
      .replace(/[\/]+/g, '/') // eslint-disable-line
      .replace(/\/\?/g, '?')
      .replace(/\/\#/g, '#') // eslint-disable-line
      .replace(/\:\//g, '://'); // eslint-disable-line
  };
  return normalize(joined);
}

/**
 * Get full path based on current location
 *
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {Location} location
 * @return {String}
 */
export function getFullUrlPath(location) {
  const isHttps = location.protocol === 'https:';
  return (
    location.protocol +
    '//' +
    location.hostname +
    ':' +
    (location.port || (isHttps ? '443' : '80')) +
    (/^\//.test(location.pathname)
      ? location.pathname
      : '/' + location.pathname)
  );
}

/**
 * Parse query string variables
 *
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {String} Query string
 * @return {String}
 */
export function parseQueryString(str) {
  let obj = {};
  let key;
  let value;
  (str || '').split('&').forEach(keyValue => {
    if (keyValue) {
      value = keyValue.split('=');
      key = decodeURIComponent(value[0]);
      obj[key] = !!value[1] ? decodeURIComponent(value[1]) : true;
    }
  });
  return obj;
}

/**
 * Decode base64 string
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {String} str base64 encoded string
 * @return {Object}
 */
export function decodeBase64(str) {
  let buffer;
  if (typeof module !== 'undefined' && module.exports) {
    try {
      buffer = require('buffer').Buffer;
    } catch (err) {
      // noop
    }
  }

  let fromCharCode = String.fromCharCode;

  let re_btou = new RegExp(
    [
      '[\xC0-\xDF][\x80-\xBF]',
      '[\xE0-\xEF][\x80-\xBF]{2}',
      '[\xF0-\xF7][\x80-\xBF]{3}',
    ].join('|'),
    'g',
  );

  let cb_btou = function(cccc) {
    switch (cccc.length) {
      case 4:
        let cp =
          ((0x07 & cccc.charCodeAt(0)) << 18) |
          ((0x3f & cccc.charCodeAt(1)) << 12) |
          ((0x3f & cccc.charCodeAt(2)) << 6) |
          (0x3f & cccc.charCodeAt(3));
        let offset = cp - 0x10000;
        return (
          fromCharCode((offset >>> 10) + 0xd800) +
          fromCharCode((offset & 0x3ff) + 0xdc00)
        );
      case 3:
        return fromCharCode(
          ((0x0f & cccc.charCodeAt(0)) << 12) |
            ((0x3f & cccc.charCodeAt(1)) << 6) |
            (0x3f & cccc.charCodeAt(2)),
        );
      default:
        return fromCharCode(
          ((0x1f & cccc.charCodeAt(0)) << 6) | (0x3f & cccc.charCodeAt(1)),
        );
    }
  };

  let btou = function(b) {
    return b.replace(re_btou, cb_btou);
  };

  let _decode = buffer
    ? function(a) {
        return (a.constructor === buffer.constructor
          ? a
          : new buffer(a, 'base64')
        ).toString();
      }
    : function(a) {
        return btou(atob(a));
      };

  return _decode(
    String(str)
      .replace(/[-_]/g, function(m0) {
        return m0 === '-' ? '+' : '/';
      })
      .replace(/[^A-Za-z0-9\+\/]/g, ''),
  );
}

export function parseCookies(str = '') {
  if (str.length === 0) return {};
  const parsed = {};
  const pattern = new RegExp('\\s*;\\s*');
  str.split(pattern).forEach(i => {
    const [encodedKey, encodedValue] = i.split('=');
    const key = decodeURIComponent(encodedKey);
    const value = decodeURIComponent(encodedValue);
    parsed[key] = value;
  });
  return parsed;
}

export function formatOptions(options) {
  const { path, domain, expires, secure } = options;
  return [
    typeof path === 'undefined' || path === null ? '' : ';path=' + path,
    typeof domain === 'undefined' || domain === null ? '' : ';domain=' + domain,
    typeof expires === 'undefined' || expires === null
      ? ''
      : ';expires=' + expires.toUTCString(),
    typeof secure === 'undefined' || secure === null || secure === false
      ? ''
      : ';secure',
  ].join('');
}

export function formatCookie(key, value, options) {
  return [
    encodeURIComponent(key),
    '=',
    encodeURIComponent(value),
    formatOptions(options),
  ].join('');
}

export function getObjectProperty(objectRef, propertyName) {
  let value = undefined;
  let valueRef = objectRef;
  const propNames = propertyName.split('.');

  for (var i = 0; i < propNames.length; i++) {
    const key = propNames[i];
    value = valueRef[key];

    if (isObject(value)) {
      valueRef = valueRef[key];
    } else {
      break;
    }
  }

  return value;
}

export function getCookieDomainUrl() {
  try {
    return $window.location.hostname;
  } catch (e) {}

  return '';
}

export function toArray(value) {
  return typeof value === 'string' || typeof value === 'number'
    ? [value]
    : value;
}

function extend(mainObj, appendObj) {
  var i,
    ii,
    key,
    data = {};

  for (key in mainObj) {
    if (
      isObject(mainObj[key]) &&
      mainObj[key].constructor.name !== 'FormData'
    ) {
      data[key] = extend(mainObj[key], {});
    } else {
      data[key] = mainObj[key];
    }
  }

  for (i = 0, ii = appendObj.length; i < ii; i++) {
    for (key in appendObj[i]) {
      if (
        isObject(appendObj[i][key]) &&
        appendObj[i][key].constructor.name !== 'FormData'
      ) {
        data[key] = extend(mainObj[key] || {}, [appendObj[i][key]]);
      } else {
        data[key] = appendObj[i][key];
      }
    }
  }

  return data;
}

function compare(one, two) {
  var i, ii, key;

  if (
    Object.prototype.toString.call(one) === '[object Object]' &&
    Object.prototype.toString.call(two) === '[object Object]'
  ) {
    for (key in one) {
      if (compare(one[key], two[key])) {
        return true;
      }
    }

    return false;
  }

  one = toArray(one);
  two = toArray(two);

  if (!one || !two || one.constructor !== Array || two.constructor !== Array) {
    return false;
  }

  for (i = 0, ii = one.length; i < ii; i++) {
    if (two.indexOf(one[i]) >= 0) {
      return true;
    }
  }

  return false;
}

export function objectDiffrence(obj1, obj2) {
  const diff = Object.keys(obj1).reduce((result, key) => {
    if (!obj2.hasOwnProperty(key)) {
      result.push(key);
    } else if (isEqual(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key);
      result.splice(resultKeyIndex, 1);
    }
    return result;
  }, Object.keys(obj2));

  return diff;
}

export function toCurrency(value) {
  return value
    .toString()
    .replace(/,/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function jsonEscape(str) {
  return str
    .replace(/\n/g, '\\\\n')
    .replace(/\r/g, '\\\\r')
    .replace(/\t/g, '\\\\t');
}

export function tagReplace(str) {
  if (str) {
    var s = str.replaceAll(/</g, '&lt;');
    s = s.replaceAll(/>/g, '&gt;');
    return s;
  } else {
    return str;
  }
}

export function toBR(str) {
  if (str) return str.replaceAll(/(?:\\r\\n|\\r|\\n)/g, '<br />');
  else return str;
}
export function toBR2(str) {
  if (str) return str.replaceAll(/(?:\r\n|\r|\n)/g, '<br />');
  else return str;
}

// 사용자 프로필 사진 선택
export function setProfile(num) {
  return (num % 16).toString();
}

// 사장님 프로필 사진 선택
export function setShopProfile(shopName, shopId, boxSize, fontSize = '24') {
  const profileColor = [
    { color: '18869e' },
    { color: '0a3895' },
    { color: '45117a' },
    { color: '3775f1' },
    { color: '6699ff' },
    { color: '7c78f9' },
    { color: '929cc0' },
    { color: '7983a4' },
    { color: '6c6c6c' },
    { color: '333333' },
  ];

  let color = '';

  if (shopId == 0) {
    color = 'ffffff';
  } else {
    color = profileColor[shopId % 10].color;
  }

  // alert(color);
  const path = `https://placehold.jp/${fontSize}/${color}/ffffff/${boxSize}.png?text=
    ${shopName}`;
  return path;
}

export function parseDaumAddress(data) {
  let fullAddress = data.address; //최종 주소
  let extraAddress = ''; //조합형 주소
  //기본 주소가 도로명 타입일때
  if (data.addressType === 'R') {
    //법정동명이 있을 경우 추가
    if (data.bname !== '') {
      extraAddress += data.bname;
    }
    //건물명이 있을 경우 추가
    if (data.buildingName !== '') {
      extraAddress +=
        extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
    }
    //조합형주소의 유무에 따라 양쪽에 괄호를 추가하여 최종주소를 만든다.
    fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
  }
  //console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  return { zipcode: data.zonecode, address: fullAddress };
}

export function downloadFile(response, fileName) {
  let result = document.createElement('a');

  let blob = new Blob([response.data], {
    type: response.headers['Content-Type'],
  });

  //파일이름이 없을 경우 기본 파일이름을 셋팅한다
  // 기본 파일이름 : export_yyyymmdd.xlsx
  if (!fileName) {
    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.indexOf('attachment') !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '');
        fileName = decodeURI(fileName);
      }
    }
  }
  //fileName = !fileName ? 'export' : fileName;
  //fileName = `${fileName}_${format(new Date(), 'yyyyMMdd')}.xlsx`;

  //this.fileCheck(fileName);

  let link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.target = '_self';
  if (fileName) link.download = fileName;
  link.click();
}

export const checkMobile = () => {
  return /iphone|ipad|android/i.test(window.navigator.userAgent);
};
export const checkMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

export function sendSms(to, message) {
  location.href =
    'sms:' +
    to +
    (checkMobileOperatingSystem() == 'iOS' ? '&' : '?') +
    'body=' +
    message;
}

export const sleep = time =>
  new Promise(resolve => setTimeout(() => resolve(), time));

//version비교(A:서버, B:앱)
//verB가 verA보다 크거나 같은지 비교.
//verB > verA이면 false, verB < verA true
export const compareVersion = (verA, verB) => {
  var isUpdate = false;
  verA = verA.split('.'); // .을 기준으로 문자열 배열로 만든다 [6][8]
  verB = verB.split('.'); // .을 기준으로 문자열 배열로 만든다 [6][7][99]

  const length = Math.max(verA.length, verB.length); // 배열이 긴쪽의 length를 구함
  for (var i = 0; i < length; i++) {
    var a = verA[i] ? parseInt(verA[i], 10) : 0; // 10진수의 int로 변환할 값이 없을 때 0으로 값을 넣습니다.
    var b = verB[i] ? parseInt(verB[i], 10) : 0;
    // alert( a +' > ' + b + ' : ' + ( a > b ) );
    if (a > b) {
      isUpdate = true;
      break;
    } else if (a < b) {
      isUpdate = false;
      break;
    }
  }
  return isUpdate;
};

/**
 * 전체 문자열 마스킹 처리
 */
export const setMasking = value => {
  if (!value) return '';
  return '*'.repeat(value.length);
};

/**
 * 이름 첫글자 마스킹 처리
 */
export const setMaskingFirst = val => {
  if (!val) return '';
  const firstChar = val.slice(0, 1);
  const rest = '*'.repeat(val.length - 1);
  return firstChar + rest;
};

/**
 * 숫자 포맷
 */
export const numberFormatter = val => {
  let result = '';

  const regex = /[^0-9]/g;
  if (regex.test(val)) {
    result = val.slice(0, -1);
  } else {
    result = val;
  }
  return result;
};

/**
 * 카드번호 포맷
 */
export const cardNumberFormatter = (input, cardNumber) => {
  if (cardNumber.length > 19) return;

  let result = '';

  let numberCheck = /[^0-9-]/g;
  let hyphenCheck = /[-]/g;
  if (numberCheck.test(cardNumber) || hyphenCheck.test(input)) {
    result = cardNumber.slice(0, -1);
  } else {
    result = cardNumber.match(/[0-9●]{1,4}/g)?.join('-') || cardNumber;
  }

  return result;
};

/**
 * 이메일 포맷
 */
export const emailFormatter = val => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[]\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!regex.test(val)) {
    return false;
  }
  return true;
};

export const mobileNumberFormat = val => {
  if (!val) return '';
  const number = val.split(' ')[1];
  const result = number.replace(/[^0-9]/g, '');
  return '0' + result;
};

const nativeUserAgentScheme = 'perce'; //_perce_cusomer, _perce_owner
const nativeAppScheme = 'perce';
const nativeActionScheme = `native://action.${nativeAppScheme}`;
window.$bridge = { deviceInfo: {}, location: {}, kakaoUserInfo: {} };
//get fbToken
window.$bridge.setDeviceInfo = function(
  device,
  uuid,
  registrationKey,
  appVersion,
  osVersion,
) {
  //alert(registrationKey);
  window.$bridge.deviceInfo.appType =
    process.env.VUE_APP_APP_NAME === 'customer' ? 'CUSTOMER' : 'OWNER';
  window.$bridge.deviceInfo.device = device;
  window.$bridge.deviceInfo.uuid = uuid;
  window.$bridge.deviceInfo.registrationKey = registrationKey;
  window.$bridge.deviceInfo.appVersion = appVersion;
  window.$bridge.deviceInfo.osVersion = osVersion;
};

window.$bridge.setKakaoLoginInfo = function(
  id,
  accountEmail,
  gender,
  ageRange,
  mobileNumber,
) {
  const providerId = 'KAKAO';
  accountEmail = accountEmail != 'null' ? accountEmail : '';
  gender = gender != 'null' ? gender : '';
  ageRange = ageRange != 'null' ? ageRange : '';
  mobileNumber = mobileNumberFormat(mobileNumber);

  let params = {
    providerId: providerId,
    providerUserId: id,
    mobileNumber: mobileNumber,
  };

  // alert(providerId);
  // alert(id);
  // alert(accountEmail);
  // alert(gender);
  // alert(ageRange);
  // alert(mobileNumber);
  let router = require('@customer/router');

  // 카카오 로그인 기록 확인
  store.dispatch('auth/SOCIAL_CHECK', params).then(res => {
    // alert('isUser = ' + res.isUser);
    // alert('userId = ' + res.userId);
    // alert('gender = ' + res.gender);
    // alert('ageRange = ' + res.ageRange);
    // alert('mobileNumber = ' + res.mobileNumber);
    // alert('nickname = ' + res.nickname);

    // 카카오 로그인 기록 있음
    if (res.isUser) {
      const passwordkey = '_KAKAO';
      const username = mobileNumber;
      const password = `${id}${mobileNumber}${passwordkey}`;

      login(username, password, 12);
    } else {
      // 카카오 로그인 기록 없음
      const reg_params = {
        providerId: 'KAKAO',
        providerUserId: id,
        email: accountEmail,
        gender: gender,
        ageRange: ageRange,
        mobileNumber: mobileNumber,
        // nickname: res.nickname,
        // areaId: region.areaId,
        // codeType: region.codeType,
      };
      // alert(1);
      // res 에서 닉네임이 있는경우 (다른 방법으로 로그인한 기록이 있음)
      if (res.nickname != '' && res.nickname != null) {
        // alert(2);
        reg_params.nickname = res.nickname;

        reg_params.joinRoute = 'APP';
        // alert('providerId = ' + reg_params.providerId);
        // alert('providerUserId = ' + reg_params.providerUserId);
        // alert('email = ' + reg_params.email);
        // alert('gender = ' + reg_params.gender);
        // alert('ageRange = ' + reg_params.ageRange);
        // alert('mobileNumber = ' + reg_params.mobileNumber);
        // alert('nickname = ' + reg_params.nickname);

        // 1. 카카오 로그인 기록 등록 (소셜 등록)
        store
          .dispatch('auth/SOCIAL_REGISTER', reg_params)
          .then(() => {
            // alert(result);
            // 기존회원
            // if (res.isUser) {
            //   // 그냥 로그인
            // } else {
            //   // 기존 회원 아님 신규 회원 가입됨
            // }

            const passwordkey = '_KAKAO';
            const username = mobileNumber;
            const password = `${reg_params.providerUserId}${mobileNumber}${passwordkey}`;

            login(username, password, 12);
          })
          .catch(e => {
            alert(e);
          });
      } else {
        // res 에서 닉네임이 없는경우
        localStorage.setItem('join_method', 'kakao');
        localStorage.setItem('join_kakao_info', JSON.stringify(reg_params));

        router.default.push({
          name: 'Auth.JoinRegion',
        });
      }
    }
  });
};

window.$bridge.setAppleLoginInfo = function(result, id) {
  const providerId = 'APPLE';

  // alert('result = ' + result);
  // alert('id = ' + id);

  if (result == 'SUCCESS') {
    if (id == '') {
      alert('로그인 실패 하였습니다.');
      return;
    } else {
      // alert('성공');
      // 로그인 성공
      // id 로 확인 API 가입한 사람이면 메인으로 이동

      // 아니면 휴대폰 인증 필요
      // store
      //   .dispatch('xeronote/FETCH_NICKNAME')
      //   .then(res => {
      //     alert(res.content[0].nickname);
      //   })
      //   .catch(() => {
      //     alert('실패');
      //   });

      var loginMethod = 'apple';
      let router = require('@customer/router');

      const providerId = 'APPLE';

      let params = {
        providerId: providerId,
        providerUserId: id,
      };

      // 애플 로그인 기록 확인
      store.dispatch('auth/SOCIAL_CHECK', params).then(res => {
        // 애플 로그인 기록 있음
        if (res.isUser) {
          const passwordkey = '_APPLE';
          const username = res.mobileNumber;
          const password = `${id}${res.mobileNumber}${passwordkey}`;
          // alert(password);
          login(username, password, 12);
        } else {
          // 애플 로그인 기록 없음
          localStorage.setItem('join_method', 'apple');
          localStorage.setItem('join_appleId', id);

          router.default.push({
            name: 'Auth.JoinMobile',
          });
        }
      });

      // if (true) {
      //   // sdk_logEvent('LOGIN_JOIN', {
      //   //   user_id: response.id,
      //   //   user_nickname: response.nickname,
      //   //   login_method: 'kakao',
      //   // });

      //   localStorage.setItem('appleLoginId', userCodeId);

      //   router.default.push({
      //     name: 'Auth.ProfileRegionPublic',
      //     query: {
      //       loginMethod: loginMethod,
      //     },
      //   });
      // } else {
      //   router.default.push({ name: 'Home' });
      // }
    }
  } else {
    alert('로그인 실패 하였습니다.');
    return;
  }
};

window.$bridge.setLocation = function(code, latitude, longitude) {
  if (window.$bridge.pageLoaded) {
    //Vue.toasted.show('위치콜백 code ' + code, { duration: 4000 });
  }
  window.$bridge.location.code = code;
  window.$bridge.location.latitude = latitude;
  window.$bridge.location.longitude = longitude;
  if (code === '1') {
    window.$bridge.location.permissionCode = '1';
    window.$bridge.location.enableGPS = '1';
  } else {
    window.$bridge.location.permissionCode = '-1';
    window.$bridge.location.enableGPS = '-1';
  }
};
window.updateLocationSetting = function(permissionCode, enableGPS) {
  //permissionCode - 1: 허용, -1: 권한없음
  //enableGPS - 1: enable, -1: disable
  if (window.$bridge.pageLoaded) {
    //Vue.toasted.show('updateLocationSetting ' + permissionCode + ',' + enableGPS, { duration: 4000 });
  }

  window.$bridge.location.permissionCode = permissionCode;
  window.$bridge.location.enableGPS = enableGPS;
  window.$bridge.location.code = permissionCode;
};
window.$bridge.setDevice = function(deviceModelName, telecomName) {
  window.$bridge.telecomName = telecomName;
  window.$bridge.deviceModelName = deviceModelName;
};
// window.$bridge.setInitLocation = function() {
// };

//device back key
window.fnBack = function() {
  router.go(-1);
};
let callbackOnClickBackKey;
export const setCallbackOnClickBackKey = cb => {
  callbackOnClickBackKey = cb || undefined;
};
window.$bridge.onClickBackKey = function() {
  if (callbackOnClickBackKey) callbackOnClickBackKey();
};
export function getDeviceInfo() {
  //- deviceType (1 : android, 2 : ios)
  //- deviceID(기기 식별값)
  //- registrationKey(FCM 푸시키)
  //- appVersion(앱버전)
  //- osVersion(기기 OS 버전)
  if (false) {
    window.$bridge.setDeviceInfo('1', '111', 'testFCM', '0.0.1');
    return;
  }
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=getRegistrationKey&callback=window.$bridge.setDeviceInfo`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}
export async function syncDeviceInfo() {
  const storageNotificationToken = localStorage.getItem('notificationToken');
  const localNotificationToken = window.$bridge.deviceInfo.registrationKey;
  if (localNotificationToken !== storageNotificationToken) {
    const isAuthenticated = await vueAuth.isAuthenticated(true);
    if (isAuthenticated) {
      store.dispatch(ROOT_UPDATE_USER_DEVICE_INFO);
    }
  }
  localStorage.setItem('notificationToken', localNotificationToken);
}
export function clearLocation() {
  window.$bridge.location = {};
}
export function nativeLocation() {
  //권한이 없을때
  //-콜백없음
  //GPS꺼져있을때
  //(-1,-1,-1)
  //GPS켜져있을때
  //(1, latitude, longitude)
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=getLocation&callback=window.$bridge.setLocation`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function isApp() {
  //if (process.client) {
  return navigator.userAgent.indexOf(`_${nativeUserAgentScheme}`) > -1;
  //}
}

export function nativeBrowse(url) {
  /*const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return;
  }*/
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  //iframe.src = 'native://action.hadpp?cmd=browse&url=' + btoa(url);
  iframe.src = `${nativeActionScheme}?cmd=browse&url=${encodeURIComponent(
    url,
  )}`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeFileDownload(url, fileName) {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=downloadFile&url=${encodeURIComponent(
    url,
  )}&fileName=${fileName}`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeNotification() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=notification`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeHideIntro() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=hideIntro`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeLandscape(types) {
  //types -> 1 : 가로모드 사용, 0 : 가로모드 해제
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=requireLandscape&type=${types}`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeSetRoot() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?isRoot=1`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeShareText(content) {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=shareText&content=${content}`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}
// 설정화면으로 이동 (1: 앱 설정화면, 2: 위치설정화면)
export function nativeGoToSetting(type) {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=goToSetting&type=${type}`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeDeviceInfo() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=getDeviceInfo&callback=window.$bridge.setDevice`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

// export function initLocation() {
//   var iframe = document.createElement('iframe');
//   iframe.style.display = 'none';
//   iframe.src = `${nativeActionScheme}?cmd=initLocation&callback=window.$bridge.setInitLocation`;
//   document.documentElement.appendChild(iframe);
//   setTimeout(() => document.documentElement.removeChild(iframe), 0);
// }

export function nativeToast(message) {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=showToast&message=${message}`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}
export function showNativeToast(message, onlyAndroid) {
  if (isApp() && checkMobileOperatingSystem() === 'Android') {
    nativeToast(message);
  } else {
    if (!onlyAndroid) alert(message);
  }
}
//startZeroNote
export function nativeStartZeroNote() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=startZeroNote`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeEnableBackKey() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=enableBack&callback=`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

export function nativeDisableBackKey() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=disableBack&callback=window.$bridge.onClickBackKey`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

// 네이티브 앱 카카오 로그인
export async function nativeKakaoLogin() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=kakaoLogin&callback=window.$bridge.setKakaoLoginInfo`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

// 네이티브 앱 애플 로그인
export async function nativeAppleLogin() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=appleLogin&callback=window.$bridge.setAppleLoginInfo`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

// 앱에서 카카오 로그인 or 애플 로그인시 사용
function login(username, password, roles = 10) {
  // alert(2);
  let loginParam = {
    username: username,
    password: password,
    roles: roles,
  };
  console.log('loginParam :: {}', loginParam);

  let router = require('@customer/router');

  store
    .dispatch('auth/LOGIN', loginParam)
    .then(() => {
      router.default.push({ name: 'Home' });
    })
    .catch(() => {
      // alert(6);
    });
}

function saveNickname(response, resNickname = '') {
  let nickname = '';
  console.log('response ======');
  console.log(response);
  nickname = resNickname;
  if (!nickname) {
    nickname = '퍼플 ' + response.id;
  }
  console.log('nickname = ' + nickname);

  const params = [{ name: 'nickname', value: nickname }];
  let payload = new FormData();
  for (const i in params) {
    payload.append(params[i].name.toString(), params[i].value);
  }

  store.dispatch('user/USER_UPDATE_ME', payload);
}

function saveDevice(userId) {
  let myDeviceName = window.$bridge.deviceModelName || ''; // SM-
  let myTelecomName = window.$bridge.telecomName || '';

  if (myDeviceName != '' || myTelecomName != '') {
    let td_param = {
      id: userId,
      deviceName: myDeviceName,
      deviceModelName: '',
      telecomName: myTelecomName,
    };

    store.dispatch('user/UPDATE_USER_TELECOM_AND_DEVICE', td_param);
  }
}

// 검색어와 일치하는 내용색 입히기
export const setKeyword = (content, keyword) => {
  let result = content;

  if (content.match(keyword)) {
    result = content.replace(keyword, `<span class="color">${keyword}</span>`);
  }
  return result;
};

export const checkNewPost = createdAt => {
  const now = moment().format('YYYY-MM-DD HH:mm:ss');
  const onedayAfter = moment(createdAt)
    .add(1, 'days')
    .format('YYYY-MM-DD HH:mm:ss');
  return now < onedayAfter;
};

export function nativeKakaoLogout() {
  var iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.src = `${nativeActionScheme}?cmd=kakaoLogout&callback=`;
  document.documentElement.appendChild(iframe);
  setTimeout(() => document.documentElement.removeChild(iframe), 0);
}

let callbackReceiveCode;
window.receiveCode = code => {
  if (callbackReceiveCode) {
    callbackReceiveCode(code);
  }
};
export const setReceiveCode = receiveFunction => {
  callbackReceiveCode = receiveFunction;
};

export const clearReceiveCode = () => {
  callbackReceiveCode = undefined;
};

let callbackForeground;
window.onForeground = () => {
  //if(checkMobileOperatingSystem() == 'iOS') {
  //  alert('onForeground');
  //}
  if (callbackForeground) {
    callbackForeground();
  }
};

let callbackBackground;
window.onBackground = () => {
  //if(checkMobileOperatingSystem() == 'iOS') {
  //  alert('onBackground');
  //}
  if (callbackBackground) {
    callbackBackground();
  }
};

export const connectedSocket = (foregroundFunction, backgroundFunction) => {
  callbackForeground = foregroundFunction;
  callbackBackground = backgroundFunction;
};

export const closeSocket = () => {
  callbackForeground = undefined;
  callbackBackground = undefined;
};

// kakao 이벤트 처리 (name 값이 추가 될때마다 추가 필요)
export function sdk_logEventKakao(name, value = '') {
  if (!name) {
    return;
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface

    switch (name) {
      case 'LOGIN_JOIN_APPLE': // 회원가입 로그인
      case 'LOGIN_JOIN_MOBILE':
      case 'LOGIN_JOIN_KAKAO':
        window.AnalyticsWebInterface.sendLoginEvent(name);

        break;

      case 'INTERNET_APPLY': // 신청서 작성
      case 'INTERNET_PROMOTION_KT_APPLY': // 신청서 작성 (프로모션)
      case 'INTERNET_PROMOTION_BANNER_CHAT': // 프로모션 배너 클릭
      case 'INTERNET_PROMOTION_BANNER_MAIN_POPUP': // 프로모션 배너 클릭
      case 'INTERNET_PROMOTION_BANNER_MAIN_CENTER': // 프로모션 배너 클릭
      case 'INTERNET_PROMOTION_BANNER_INTERNET_MAIN_CENTER': // 프로모션 배너 클릭
      case 'INTERNET_ESTIMATE': // 견적요청서
      case 'INTERNET_CHAT': // 상담 신청
      case 'INTERNET_PROMOTION_KT_CHAT': // 프로모션 KT 상담
      case 'MOBILE_ESTIMATE': // 휴대폰 견적서
      case 'SHOP_TEL': // 매장 연락
        window.AnalyticsWebInterface.sendParticipationEvent(name);

        break;

      default:
        window.AnalyticsWebInterface.sendParticipationEvent(name);
    }
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.firebase
  ) {
    let command = '';
    switch (name) {
      case 'LOGIN_JOIN_APPLE': // 회원가입 로그인
      case 'LOGIN_JOIN_MOBILE':
      case 'LOGIN_JOIN_KAKAO':
        command = 'sendLoginEvent';
        // Call iOS interface

        break;
      case 'INTERNET_APPLY': // 신청서 작성
      case 'INTERNET_PROMOTION_KT_APPLY': // 신청서 작성 (프로모션)
      case 'INTERNET_PROMOTION_BANNER_CHAT': // 프로모션 배너 클릭
      case 'INTERNET_PROMOTION_BANNER_MAIN_POPUP': // 프로모션 배너 클릭
      case 'INTERNET_PROMOTION_BANNER_MAIN_CENTER': // 프로모션 배너 클릭
      case 'INTERNET_PROMOTION_BANNER_INTERNET_MAIN_CENTER': // 프로모션 배너 클릭
      case 'INTERNET_ESTIMATE': // 견적요청서
      case 'INTERNET_CHAT': // 상담 신청
      case 'INTERNET_PROMOTION_KT_CHAT': // 프로모션 KT 상담
      case 'MOBILE_ESTIMATE': // 휴대폰 견적서
      case 'SHOP_TEL': // 매장 연락
        command = 'sendParticipationEvent';

        break;

      default:
        command = 'sendParticipationEvent';
    }

    // Call iOS interface
    var message = {
      command: command,
      name: name,
      value: value,
    };
    window.webkit.messageHandlers.firebase.postMessage(message);
  } else {
    // No Android or iOS interface found

    console.log('No native APIs found.');
  }
}

// GA4 로그이벤트 처리, facebook 메타 이벤트 처리
export function sdk_logEvent(name, params) {
  if (!name) {
    return;
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface
    window.AnalyticsWebInterface.logEvent(name, JSON.stringify(params));
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.firebase
  ) {
    // Call iOS interface
    var message = {
      command: 'logEvent',
      name: name,
      parameters: params,
    };
    window.webkit.messageHandlers.firebase.postMessage(message);
  } else {
    // No Android or iOS interface found
    console.log('No native APIs found.');
  }
}
// GA4 로그이벤트 처리 ( 사용안함 - 테스트용 )
export function setUserProperty(name, value) {
  if (!name || !value) {
    return;
  }

  if (window.AnalyticsWebInterface) {
    // Call Android interface
    window.AnalyticsWebInterface.setUserProperty(name, value);
  } else if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.firebase
  ) {
    // Call iOS interface
    var message = {
      command: 'setUserProperty',
      name: name,
      value: value,
    };
    window.webkit.messageHandlers.firebase.postMessage(message);
  } else {
    // No Android or iOS interface found
    console.log('No native APIs found.');
  }
}

export function numberToKorean(number, korean = true) {
  var inputNumber = number < 0 ? false : number;
  var unitWords = ['', '만', '억', '조', '경'];
  var splitUnit = 10000;
  var splitCount = unitWords.length;
  var resultArray = [];
  var resultString = '';

  for (var i = 0; i < splitCount; i++) {
    var unitResult =
      (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
    unitResult = Math.floor(unitResult);
    if (unitResult > 0) {
      resultArray[i] = unitResult;
    }
  }

  for (var k = 0; k < resultArray.length; k++) {
    if (!resultArray[k]) continue;
    if (korean) {
      resultString = String(resultArray[k]) + unitWords[k] + resultString;
    } else {
      resultString = String(resultArray[k]) + resultString;
    }
  }

  return resultString;
}

// 로그인 여부 확인
export async function isAuth() {
  const isAuthenticated = await vueAuth.isAuthenticated(true);
  console.log('isAuthenticated');
  console.log(isAuthenticated);
  return isAuthenticated;
}
